// extracted by mini-css-extract-plugin
module.exports = {"display":"DateTimeUTCDisplay_display__2M7_s"};